import type { PerformanceSeries } from '@algoboo/schema/api'

/**
 * The platform's performance of an agent (lane ALGOBOO1): its book's cumulative net P&L in ETH as sparkline points,
 * oldest first; empty when the platform has no result (never a line at zero).
 */
export function perfSeries(p: PerformanceSeries | undefined): { t: string; v: string }[] | undefined {
  if (!p) return undefined
  return (p.pointsEth ?? []).map((x) => ({ t: x.asOf, v: x.pnlEth }))
}

/** The platform's max drawdown of the book `scope` names, in ETH; null when unknown, undefined while loading. */
export function perfDrawdownEth(p: PerformanceSeries | undefined): string | null | undefined {
  if (!p) return undefined
  const book = p.scope ? p.books?.[p.scope] : null
  return book?.maxDrawdownEth ?? null
}
